import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { ChecklisteFragaModel } from "../../models/checklist-models";

export class UpdateKontraktChecklistaCommand extends BasicCommand<UpdateKontraktChecklistaCommand> {
    readonly kontraktGuid: string;
    readonly checklisteFragor: ChecklisteFragaModel[] = [];

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateKontraktChecklistaCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Checklista";

    get primaryKey(): IPrimaryKey<UpdateKontraktChecklistaCommand> {
        return {
            kontraktGuid: this.kontraktGuid
        };
    }

    constructor(kontraktGuid: string, checklisteFragor: ChecklisteFragaModel[]) {
        super(UpdateKontraktChecklistaCommand.$type, UpdateKontraktChecklistaCommand.$groupKey, CommandType.Replace);
        this.kontraktGuid = kontraktGuid;
        this.checklisteFragor = checklisteFragor;
    }
}
